export default __webpack_public_path__ + "static/media/confirmPayment.113861ef.svg";